import { render, staticRenderFns } from "./userHeader.vue?vue&type=template&id=1ffc00e0&"
import script from "./userHeader.vue?vue&type=script&lang=js&"
export * from "./userHeader.vue?vue&type=script&lang=js&"
import style0 from "./userHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports